<template>
  <div>
    <v-form v-model="valid" ref="searchForm">
      <v-card dark style="border-radius: 10px">
        <v-layout row wrap class="pa-3">
          <v-flex xs12 sm4 class="pa-2 search__input">
            <v-menu
              :close-on-content-click="false"
              v-model="menu1"
              :nudge-right="-30"
              lazy
              transition="scale-transition"
              offset-y
              style="width: 100%"
            >
              <v-text-field
                v-model="config_path.datetime_start"
                slot="activator"
                prepend-icon="event"
                readonly
                label="Start"
                :rules="[(v) => !!v || 'Required']"
              ></v-text-field>
              <v-date-picker
                color="#333"
                v-model="config_path.datetime_start"
                no-title
                @input="menu1 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm4 class="pa-2 search__input">
            <v-menu
              :close-on-content-click="false"
              v-model="menu2"
              :nudge-right="-30"
              lazy
              transition="scale-transition"
              offset-y
              style="width: 100%"
            >
              <v-text-field
                v-model="config_path.datetime_end"
                slot="activator"
                prepend-icon="event"
                readonly
                label="End"
                :rules="[(v) => !!v || 'Required']"
              ></v-text-field>
              <v-date-picker
                color="#333"
                v-model="config_path.datetime_end"
                no-title
                @input="menu2 = false"
              ></v-date-picker>
            </v-menu>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex
            xs12
            sm2
            style="display: flex; justify-content: center; align-items: center"
          >
            <div class="text-xs-center search-btn" @click="search()">
              <v-progress-circular
                indeterminate
                color="black"
                v-if="searching"
              ></v-progress-circular>
              <v-icon large color="black" v-else>search</v-icon>
            </div>
          </v-flex>
        </v-layout>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  props: {},
  data() {
    return {
      valid: true,
      menu1: false,
      menu2: false,
      config_path: {
        hotel_id: 0,
        datetime_start: null,
        datetime_end: null,
      },
      searching: false,
    };
  },
  created() {
    Object.assign(this.config_path, this.clone_config_path);
  },
  computed: {
    ...mapState({
      clone_config_path: (state) => state.hotelReport.clone_config_path,
    }),
  },
  methods: {
    ...mapActions({
      fetchHotelOrderReport: "hotelReport/fetchHotelOrderReport",
    }),
    async search() {
      if (!this.$refs.searchForm.validate() || this.searching == true) return;
      this.searching = true;
      await this.fetchHotelOrderReport(this.config_path);
      this.searching = false;
    },
  },
};
</script>

<style scoped>
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.search-btn {
  cursor: pointer;
  height: 50px;
  width: 50px;
  background-color: #ffd300;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.search__input {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
